import { render, staticRenderFns } from "./InventoryCard.vue?vue&type=template&id=0523bd77&scoped=true"
import script from "./InventoryCard.vue?vue&type=script&lang=js"
export * from "./InventoryCard.vue?vue&type=script&lang=js"
import style0 from "./InventoryCard.vue?vue&type=style&index=0&id=0523bd77&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523bd77",
  null
  
)

export default component.exports